import { DetailTemplate } from "../../templates/DetailTemplate";
import { MainTemplate } from "../../templates/MainTemplate";
import { useUserDetail } from "./hook";

export const UserDetailPage: React.FC = () => {
  const { userDetail, handleCancel, handleEdit } = useUserDetail();

  return (
    <MainTemplate title="アカウント詳細" useFitHeight>
      <DetailTemplate
        detailItems={userDetail}
        onCancel={handleCancel}
        onEdit={handleEdit}
      />
    </MainTemplate>
  );
};
